import { isEmpty } from '@ember/utils';
import Enum from '@square/dashboard-utilities/utils/enum';
export const GroupType = new Enum('MANUAL_GROUP', 'AUDIENCE_GROUP', 'INTERNAL_GROUP');

// create a mutable copy of groups, but only the manual ones
// (smart groups cannot be removed by the merchant)
export function copyGroupsForEditing(contact) {
  contact.set('editableGroups', (contact.get('group') || []).filterBy('groupType', GroupType.MANUAL_GROUP).sortBy('name'));
}

// add back the non-editable groups when committing the
// changes to the editable groups
export function materializeGroups(contact) {
  const groups = (contact.get('group') || []).rejectBy('groupType', GroupType.MANUAL_GROUP).concat(contact.get('editableGroups') || []); // eslint-disable-line unicorn/prefer-spread
  const newGroups = isEmpty(groups) ? null : groups;
  contact.set('group', newGroups);
}
export function groupToUrlIdentifier(group) {
  const groupNameSafe = encodeURI(group.name.replace(/[/<>?\\-]/g, ''));
  const groupToken = group.groupToken;
  return `${groupNameSafe}-${groupToken}`;
}
export function segmentToUrlIdentifier(segment) {
  const groupNameSafe = encodeURI(segment.name.replace(/[/<>?\\-]/g, ''));
  const groupToken = segment.segmentTokenPair.serverToken;
  return `${groupNameSafe}-${groupToken}`;
}